import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { FaArrowRight, FaHandHoldingHeart, FaLeaf, FaSeedling, FaUsers } from "react-icons/fa";

// Single hero background image
import bannerBg from '../assets/image8.jpg';

export default function HomeBanner(props) {
    const appContext = useContext(AppContext);
    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Initialization space
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div className="MainBodySection position-relative overflow-hidden hero-banner-viewport">
                {/* Background Image Container */}
                <div 
                    className="hero-single-bg"
                    style={{ backgroundImage: `url(${bannerBg})` }}
                />
                
                {/* Refined Ambient Overlay (Not Pitch Dark) */}
                <div className="hero-overlay d-flex align-items-center">
                    <div className="container position-relative hero-content-wrapper my-auto">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-10 col-xl-9">
                                
                                {/* Central Glassmorphic Hero Panel */}
                                <div className="hero-glass-card text-center p-4 p-md-5">
                                    
                                    {/* Top Tag & Badge */}
                                    <div className="d-inline-flex align-items-center gap-2 hero-badge font-semi-bold text-uppercase mb-3">
                                        <span className="hero-badge-dot"></span>
                                        <span>Mwananchi Development Organization</span>
                                    </div>

                                    {/* Main Headline */}
                                    <h1 className="title-font-bold text-light hero-main-title mb-3">
                                        Empowering Communities, <br className="d-none d-md-inline" />
                                        Transforming Agriculture in Tanzania
                                    </h1>

                                    {/* Sub-headline / Mission Excerpt */}
                                    <p className="font-regular hero-sub-title mb-4">
                                        Lifting the living standards of smallholder farmers and vulnerable communities 
                                        through modern agricultural skills, climate change resilience, and capacity building.
                                    </p>

                                    {/* Quick Impact Tags Bar */}
                                    <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">
                                        <span className="hero-pill-tag font-light">
                                            <FaSeedling className="me-1 text-secondary-color" /> Modern Farming
                                        </span>
                                        <span className="hero-pill-tag font-light">
                                            <FaLeaf className="me-1 text-secondary-color" /> Climate Resilience
                                        </span>
                                        <span className="hero-pill-tag font-light">
                                            <FaUsers className="me-1 text-secondary-color" /> Capacity Building
                                        </span>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="d-flex flex-wrap justify-content-center gap-3">
                                        <button
                                            className="btn btn-hero-primary title-font-semi-bold d-inline-flex align-items-center gap-2"
                                            onClick={() => appContext.navTo({ item: 'services' })}
                                        >
                                            <span>Our Objectives</span>
                                            <FaArrowRight size={14} />
                                        </button>
                                        <button
                                            className="btn btn-hero-outline title-font-semi-bold d-inline-flex align-items-center gap-2"
                                            onClick={() => appContext.navTo({ item: 'contact_us' })}
                                        >
                                            <FaHandHoldingHeart size={15} />
                                            <span>Get Involved</span>
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                {getInlineLoader()}
            </div>
        );
    }
}